import {Deal} from "@irati/types"

export default (deal: Deal) => deal.productConfig?.products?.[0]?.data?.externalMetadata?.openValue
